import React from "react";
import { Modal } from "@/components";
import { ModalTexts } from "@/resources/locale";
import { Button } from "@/components";
import { useModalNavigation } from "../../hooks/useModalNavigation";
import styles from "./AuthErrorModal.module.scss";

interface AuthErrorModalProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
}

export const AuthErrorModal: React.FC<AuthErrorModalProps> = ({
  isOpen,
  setIsOpen,
  onClose,
}) => {
  const { handleAuth } = useModalNavigation();

  return (
    <Modal
      title={ModalTexts.auth.authError.TITLE}
      subTitle={ModalTexts.auth.authError.SUB_TITLE}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      closeModal={onClose}
    >
      <Button newStyles={styles.button} onClickFunc={handleAuth}>
        Назад
      </Button>
    </Modal>
  );
};

